// @flow
import { Cookies } from 'react-cookie';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { fetchJSON } from '../../helpers/api';
import { ApiCall } from '../../services/index';
import { endpoints } from '../../services/endpoints';
import { toast, ToastContainer, Zoom } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ASSET_LIST, ASSET_ADD, ASSET_UPDATE, ASSET_DELETE } from './constants';

import {
    getAssetListSuccess,
    getAssetListFailed,
    getAssetAddSuccess,
    getAssetAddFailed,
    getAssetUpdateSuccess,
    getAssetUpdateFailed,
    getAssetDeleteSuccess,
    getAssetDeleteFailed,
} from './actions';

import { getLoggedInUser } from '../../helpers/authUtils';

const assetAddedSucsess = () => toast.success('Asset Added Successfully', { transition: Zoom });
const assetDeletedSuccess = () => toast.success('Asset Deleted Successfully', { transition: Zoom });
const assetUpdated = () => toast.info('Asset Updated Successfully', { transition: Zoom });
const emptyAllFields = () => toast.warning('Please fill all fields', { transition: Zoom });
const WarnFields = (msg) => toast.error(msg, { transition: Zoom });
/**
 * Get Asset List
 * @param {*} payload - asset number/type
 */
function* AssetList  ({payload : data}){
    const user = getLoggedInUser();
    let rolenum = getLoggedInUser().role_number;

 
    let options = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + user.token,          
            
        },

      

        method: 'GET',
        url: endpoints.assetList,
        
    };


    try {
        const response = yield call(ApiCall, options);

        yield put(getAssetListSuccess(response.data));
    } catch (error) {
        let message;
        switch (error.response.status) {
            case 500:
                message = 'Internal Server Error';
                WarnFields(message);
                break;
            case 401:
                message = 'Invalid credentials';
                WarnFields(message);
                break;
            case 400:
                message = error.response.data && error.response.data.error;
                WarnFields(message);
                break;
            default:
                message = error;
        }
        yield put(getAssetListFailed(message));
    }
}

// Asset Add

function* AssetAdd({ payload: data }) {
    const user = getLoggedInUser();

    let options = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + user.token,
        },
        method: 'POST',
        url: endpoints.assetList,
        data: data,
    };

    try {
        const response = yield call(ApiCall, options);
        assetAddedSucsess();
        yield put(getAssetAddSuccess(response.data));
    } catch (error) {
        let message;
        switch (error.response.status) {
            case 500:
                message = 'Internal Server Error';
                WarnFields(message);
                break;
            case 401:
                message = 'Invalid credentials';
                WarnFields(message);
                break;
            case 400:
                message = error.response.data && error.response.data.error;
                WarnFields(message);
                break;
            default:
                message = error;
        }
        yield put(getAssetAddFailed(message));
    }
}

// Asset Update

function* AssetUpdate({ payload: data }) {
    const user = getLoggedInUser();

    let options = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + user.token,
        },
        method: 'PUT',
        url: endpoints.assetList + '/' + (data && data.id),
        data: data,
    };

    try {
        const response = yield call(ApiCall, options);
        assetUpdated();
        yield put(getAssetUpdateSuccess(response.data));
    } catch (error) {
        let message;
        switch (error.response.status) {
            case 500:
                message = 'Internal Server Error';
                WarnFields(message);
                break;
            case 401:
                message = 'Invalid credentials';
                WarnFields(message);
                break;
            case 400:
                message = error.response.data && error.response.data.error;
                WarnFields(message);
                break;
            default:
                message = error;
        }
        yield put(getAssetUpdateFailed(message));
    }
}

// Asset Delete

function* AssetDelete({ payload: id }) {
    const user = getLoggedInUser();

    let options = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + user.token,
        },
        method: 'DELETE',
        url: endpoints.assetList + '/' + id,
    };

    try {
        const response = yield call(ApiCall, options);
        assetDeletedSuccess();
        yield put(getAssetDeleteSuccess(response.data));
    } catch (error) {
        let message;
        switch (error.response.status) {
            case 500:
                message = 'Internal Server Error';
                WarnFields(message);
                break;
            case 401:
                message = 'Invalid credentials';
                WarnFields(message);
                break;
            case 400:
                message = error.response.data && error.response.data.error;
                WarnFields(message);
                break;
            default:
                message = error;
        }
        yield put(getAssetDeleteFailed(message));
    }
}

export function* watchAssetList(): any {
    yield takeEvery(ASSET_LIST, AssetList);
}
export function* watchAssetAdd(): any {
    yield takeEvery(ASSET_ADD, AssetAdd);
}
export function* watchAssetUpdate(): any {
    yield takeEvery(ASSET_UPDATE, AssetUpdate);
}
export function* watchAssetDelete(): any {
    yield takeEvery(ASSET_DELETE, AssetDelete);
}

function* assetSaga(): any {
    yield all([
        fork(watchAssetList),
        fork(watchAssetAdd),
        fork(watchAssetUpdate),
        fork(watchAssetDelete),
    ]);
}

export default assetSaga;

